import { useEffect, useState } from "react";

import classnames from "classnames";

import { XMaxLocker, XMinLocker } from "../AxisLocker";
import { MpLockWrapper } from "../AxisLocker/AxisLocker.styles";
import { Wrapper } from "./AxisContainer.styles";

export function XAxisContainer({
  onInputStateChange,
  isMultiProductActive = false,
  xAxisArray = []
}) {
  const [isInputActive, setIsInputActive] = useState(false);

  useEffect(() => {
    onInputStateChange(isInputActive);
  }, [isInputActive, onInputStateChange]);

  const wrapperClassnames = classnames({
    xAxis: true
  });

  // If multiProduct is active, render each axis pair positioned using the
  // dynamically computed lockPosition from chart options.
  if (isMultiProductActive && xAxisArray.length >= 1) {
    return (
      <>
        {xAxisArray.map((axis, index) => {
          const lockPos = axis?.lockPosition;
          if (lockPos == null) {
            // Fallback: render at default position if lockPosition not yet computed
            return (
              <Wrapper key={index} className={wrapperClassnames}>
                <XMaxLocker onInputStateChange={setIsInputActive} xAxisIndex={index} />
                <XMinLocker onInputStateChange={setIsInputActive} xAxisIndex={index} />
              </Wrapper>
            );
          }
          return (
            <div
              key={index}
              style={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
              <MpLockWrapper
                $lockPosition={lockPos}
                $variant="min"
                data-axis-index={index}
                data-variant="x-min">
                <XMinLocker onInputStateChange={setIsInputActive} xAxisIndex={index} />
              </MpLockWrapper>
              <MpLockWrapper
                $lockPosition={lockPos}
                $variant="max"
                data-axis-index={index}
                data-variant="x-max">
                <XMaxLocker onInputStateChange={setIsInputActive} xAxisIndex={index} />
              </MpLockWrapper>
            </div>
          );
        })}
      </>
    );
  }

  // Default single axis behavior
  const primaryAxis = xAxisArray[0];
  if (primaryAxis?.isTotalRateDateLockPosition && primaryAxis?.lockPosition) {
    return (
      <div style={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
        <MpLockWrapper
          $lockPosition={primaryAxis.lockPosition}
          $variant="min"
          data-axis-index={0}
          data-variant="x-min">
          <XMinLocker onInputStateChange={setIsInputActive} />
        </MpLockWrapper>
        <MpLockWrapper
          $lockPosition={primaryAxis.lockPosition}
          $variant="max"
          data-axis-index={0}
          data-variant="x-max">
          <XMaxLocker onInputStateChange={setIsInputActive} />
        </MpLockWrapper>
      </div>
    );
  }

  return (
    <Wrapper className={wrapperClassnames}>
      <XMaxLocker onInputStateChange={setIsInputActive} />
      <XMinLocker onInputStateChange={setIsInputActive} />
    </Wrapper>
  );
}
